function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialSoftphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.78,15.39a4.35,4.35,0,0,0-3.42,1.82,4.12,4.12,0,0,0-.81,2.32h0c-.43.07-.81.86-.63,1.85s.49,1.72.92,1.72h0l1.5-.14a.47.47,0,0,0,.43-.49h0l-.29-2.58a.47.47,0,0,0-.5-.42h-.4a3.66,3.66,0,0,1,.57-1.63A3,3,0,0,1,23.37,17l.13.1a3.34,3.34,0,0,1,1.32,2.36h-.35a.62.62,0,0,0-.5.42l-.19,2.73a.44.44,0,0,0,.07.35.57.57,0,0,0,.37.16l1.5.13h0c.35,0,.63-.42.81-1v.07a.62.62,0,0,1,.07.64l-.49,1.07a.94.94,0,0,1-.86.57H24.7a.46.46,0,0,0-.35-.28H23.21a.48.48,0,0,0-.43.44v.48a.49.49,0,0,0,.43.44h1.21a.33.33,0,0,0,.35-.29h.66a1.63,1.63,0,0,0,1.49-1l.51-1.08A1.36,1.36,0,0,0,27.25,22a1.57,1.57,0,0,0-.57-.49c.08-1-.2-1.79-.71-1.86h0a4.17,4.17,0,0,0-4.06-4.22Z",
    style: {
      fill: "#00a9ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.45,20l-.26.16c-.53.35-2.46.19-4-2.66s-.82-4.68-.27-4.89L10.94,12a1.13,1.13,0,0,0,.45-1.41L9.33,6.84A1.13,1.13,0,0,0,7.91,6.4c0,.08-1.15.62-1.15.71C5.19,8,4.38,9.84,4.47,12.44a15.41,15.41,0,0,0,2.2,6.85,17,17,0,0,0,4.77,5.4,8.56,8.56,0,0,0,2,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialSoftphone);
export default __webpack_public_path__ + "static/media/dial-softphone.16e1a2db.svg";
export { ForwardRef as ReactComponent };